import { useState } from 'react';

export interface Toast {
    id: string;
    type: 'success' | 'error' | 'warning' | 'info';
    title: string;
    message: string;
    duration?: number; // Optional duration override
}

export const useToast = () => {
    const [toasts, setToasts] = useState<Toast[]>([]);

    const addToast = (
        type: Toast['type'],
        title: string,
        message: string,
        duration: number = 5000
    ) => {
        const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
        const newToast: Toast = { id, type, title, message, duration };

        setToasts(prev => [...prev, newToast]);

        // Auto-remove after duration
        setTimeout(() => {
            removeToast(id);
        }, duration);
    };

    const removeToast = (id: string) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };

    const clearAllToasts = () => {
        setToasts([]);
    };

    // Convenience methods
    const success = (title: string, message: string, duration?: number) =>
        addToast('success', title, message, duration);

    const error = (title: string, message: string, duration?: number) =>
        addToast('error', title, message, duration);

    const warning = (title: string, message: string, duration?: number) =>
        addToast('warning', title, message, duration);

    const info = (title: string, message: string, duration?: number) =>
        addToast('info', title, message, duration);

    return {
        toasts,
        addToast,
        removeToast,
        clearAllToasts,
        success,
        error,
        warning,
        info
    };
};